import Resources from '../../../helpers/resources';
import DateParamHelper from '../../../helpers/date-param-helper';
import css from './student.scss';
import errorActions from '../../app/errors/errors-actions';
import { ENDPOINT_PATH_ACTIVITY_MASTERY } from '../../../helpers/constants';

export const ACTIVITY_MASTERY_STUDENT_RETRIEVED =
    'ACTIVITY_MASTERY_STUDENT_RETRIEVED';

function getActivityMasteryData(
    classroomId,
    studentProfileId,
    selectedDateFilter
) {
    return (dispatch) =>
        Resources.studentReport
            .get({
                reportType: ENDPOINT_PATH_ACTIVITY_MASTERY,
                ...DateParamHelper.getDateTypePath(selectedDateFilter),
                classroomId,
                userProfileId: studentProfileId
            })
            .withParams(DateParamHelper.getDateQueryParams(selectedDateFilter))
            .send()
            .then((payload) => {
                if (payload.valid) {
                    dispatch({
                        type: ACTIVITY_MASTERY_STUDENT_RETRIEVED,
                        payload: mapActivityMasteryData(payload.data)
                    });
                } else {
                    dispatch(
                        errorActions.addError(
                            ACTIVITY_MASTERY_STUDENT_RETRIEVED
                        )
                    );
                }
            });
}

function mapActivityMasteryData(data) {
    const topicActivityResults = data.topicActivityResults.map(
        (result, index) => {
            result.id = index;
            result.activityResultDetails = result.activityResultDetails.map(
                (detail, i) => {
                    detail = mapResult(detail, i);
                    if (detail.isAssigned) {
                        detail.className = css.assigned;
                    }
                    return detail;
                }
            );
            return result;
        }
    );
    const strengths = {
        topics: mapStrengthWeakness(data.topicStrengths),
        activities: mapStrengthWeakness(data.activityStrengths)
    };
    const weaknesses = {
        topics: mapStrengthWeakness(data.topicWeaknesses, false),
        activities: mapStrengthWeakness(data.activityWeaknesses, false)
    };

    return {
        className: data.className,
        courseInfo: data.courseInfo,
        topicActivityResults,
        testResults: data.testResults.map(mapResult),
        strengths,
        weaknesses
    };
}

function mapStrengthWeakness(strengthWeakness, descending = true) {
    const defaultData = {
        id: 0,
        title: '-',
        averageResult: '- '
    };

    if (!strengthWeakness.length) {
        return [defaultData];
    }

    let sorted;
    if (descending) {
        sorted = strengthWeakness.sort(
            (a, b) => a.averageResult < b.averageResult
        );
    } else {
        sorted = strengthWeakness.sort(
            (a, b) => a.averageResult > b.averageResult
        );
    }

    return sorted.map((data, idx) => ({
        ...data,
        id: idx
    }));
}

function mapResult(result, idx) {
    result.id = idx;
    if (result.result === 0 && result.attempts === 0) {
        result.result = -1;
    }
    return result;
}

export default {
    getActivityMasteryData
};



// WEBPACK FOOTER //
// ./containers/activity-mastery/student/student-actions.js